<div *ngIf="imageSrc" class="text-center public-responsive">
    <h1>Gate Pass Barcode</h1>
    <br>
    <img [src]="imageSrc" alt="Gate Pass Barcode">
    <br>
    <app-driver-check-in-support-button [driver]="driver" [pickup]="pickup"></app-driver-check-in-support-button>
    <br>
</div>